import Toolbar from '@/components/Toolbar';
import { cn } from '@/lib/utils';

const PageLayout = ({
  children,
  className,
  renderOptions,
  subtitle,
  title,
  toolbarHead,
  toolbarTail,
}) => {
  return (
    <>
      <Toolbar>
        <div className="space-x-3">{toolbarHead && toolbarHead}</div>
        <div className="space-x-3">{toolbarTail && toolbarTail}</div>
      </Toolbar>
      <div
        className={cn(
          'print-area',
          'flex-1 mt-14 p-4 sm:p-6 lg:p-8',
          className
        )}
      >
        <div className="flex items-start justify-between">
          <div className="mb-4 space-y-1">
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">
              {title}
            </h2>
            <p className="text-sm sm:text-base text-muted-foreground">
              {subtitle}
            </p>
          </div>
          {renderOptions && <div>{renderOptions()}</div>}
        </div>
        {children}
      </div>
    </>
  );
};

export default PageLayout;
